import React from "react";
import "../EmailTemplates/EmailTemplates.scss";


const EmailTemplates = () => {
  return (
    <>
      <div style={{ fontFamily: "Inter", minWidth:"1000px", overflow:"auto", lineHeight:"2"}}>
        <div style={{margin:"50px auto", width:"70%",padding:"20px 0"}}>
          <div style={{borderBottom:"1px solid #eee", marginBottom:"16px"}}>
            <a
              href=""
              style={{fontSize:"30px", color: "#4F46E5", textDecoration:"none", fontWeight:"600"}}
            >
              Your Brand
            </a>
          </div>
          <p style={{fontSize:"14px", color: "#4B5563", fontFamily: "Inter", margin:"0px"}}>Hi,</p>
          <p style={{fontSize:"14px", color: "#4B5563", fontFamily: "Inter"}}>
            Thank you for choosing Your Brand. Use the following OTP to complete
            your Sign Up procedures. OTP is valid for 5 minutes
          </p>
          <h2 style={{background: "#4F46E5", letterSpacing:"5px", margin: "30px auto", width: "max-content", padding: "0 10px", color: "#fff", borderRadius: "4px", fontFamily: "Inter"}}>
            324457
          </h2>
          <p style={{fontSize:"14px", color: "#1F2937", fontFamily: "Inter"}}>
            Regards,
            <br />
            Your Brand
          </p>
          <hr style={{border:"none", borderTop:"1px solid #eee" }}/>
          <div style={{float:"right", padding:"8px 0", color:"#9CA3AF", fontSize:"12px", lineHeight:"1", fontWeight:"300", fontFamily: "Inter"}}>
            <p>Your Brand Inc</p>
            <p>1600 Amphitheatre Parkway</p>
            <p>California</p>
          </div>
        </div>
      </div>

      
    </>
  );
};

export default EmailTemplates;
